import React from "react";
import GridTimeline from "./GridTimeline.jsx";
import TimelineHours from "./TimelineHours.jsx";

/* The Trainers timeline: one month, one row per trainer, one cell per day.
   Every row and cell arrives resolved from GET
   /classroom-management/schedule/month (kind=trainers) -- teaching, free or
   absent, the label, that day's sessions and any leave -- so this only hands
   them to the grid and reports which cell was clicked. */
const TrainersTimelineView = ({ data, onCellClick, onRowOpen }) => {
  const rows = data?.rows || [];
  const rowByKey = new Map(rows.map((r) => [r.key, r]));

  return (
    <>
      <GridTimeline
        dates={(data?.dates || []).map((d) => d.date)}
        rows={rows}
        onCellClick={(date, key) => onCellClick(rowByKey.get(key), date)}
        onRowOpen={onRowOpen ? (key) => onRowOpen(rowByKey.get(key)) : undefined}
        dense
      />
      {/* The same month and the same rows, read as hours rather than as a
          grid: the grid says WHEN, this says HOW MUCH. */}
      <TimelineHours hours={data?.hours} rows={rows} kind="trainers" />
    </>
  );
};

export default TrainersTimelineView;
